export const pravilnik_o_radu= {
    templateId: 222,
    category: 14,
    templateTitle: 'Pravilnik o radu',
    templateDescription: `<p>Poslodavac koji zapošljava najmanje dvadeset radnika dužan je donijeti i objaviti pravilnik o radu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Poslodavac koji zapošljava najmanje dvadeset radnika dužan je donijeti i objaviti pravilnik o radu kojim se uređuju:</p>
    <li> plaće, organizacija rada (prijedlog je navedeno definirati posebnim pravilnikom koji se nalazi <a class="local-link" href="/contract?template=221">ovdje</a>),</li>
    <li> postupak i mjere za zaštitu dostojanstva radnika,</li>
    <li> mjere zaštite od diskriminacije i</li>
    <li> druga pitanja važna za radnike zaposlene kod poslodavca,</li>
    <br>
    <p> ako ta pitanja nisu uređena kolektivnim ugovorom.</p>
    <p>Osim spomenutih glavnih pitanja, poslodavac mora pravilnikom o radu urediti i sljedeća dodatna pitanja:</p>
    <li> koje osobne podatke će od radnika  prikupljati, obrađivati, koristiti ili dostavljati trećim osobama radi ostvarivanja prava i obveza iz radnog odnosa,</li>
    <li> osposobljavanja pripravnika za samostalni rad, ako to nije određeno ugovorom o radu, </li>
    <li> raspored radnog vremena, ako nije određen posebnom odlukom (prijedlog je da se uredi posebnom odlukom koju možete pogledati <a class="local-link" href="/contract?template=27">ovdje</a>).</li>
    <br>
    <p>Važno je napomenuti da ne mora svaki poslodavac imati pravilnik o radu, nego samo poslodavci koji zapošljavaju 20 i više radnika.</p>
    <p>Poslodavac može u jednom pravilniku (pravilniku o radu) regulirati gore navedena pitanja, a može usvojiti i više posebnih pravilnika koji se odnose na određene radnike, npr. samo za radnike određenog organizacijske jedinice poslodavca ili samo za radnike koji rade na terenu i sl..</p>
    <p>Osim gore navedenih pitanja, poslodavac po slobodnoj volji može pravilnikom o radu definirati odmore i dopuste,  otkazne rokove, dodatke na plaću te razdoblje isplate primanja na koja radnik ima pravo,  razloge za otkaz, način dostave otkaza i ostalih dokumenata, mjere kontrole (prisutnost alkohola i droga), dodatna materijalna prava radnika (neoporozive isplate - prigodne nagrade, dar djetetu, putni troškovi i sl..), zabranu natjecanja radnika s poslodavcem i sl..</p>
    <p>U praksi, postupak donošenja i izmjena/dopuna pravilnika o radu ovisi o tome je li kod poslodavca formirano radničko vijeće, odnosno djeluje li kod poslodavca sindikalni povjerenik ili ne. </p>
    <p>Poslodavac kod kojeg je formirano radničko vijeće ili djeluje sindikalni povjerenik,  mora se prije donošenja pravilnika o radu ili u slučaju izmjena/dopuna pravilnika o radu, savjetovati s radničkim vijećem (ukoliko su radnici formirali radničko vijeće) odnosno sindikalnim povjerenikom (ukoliko je sindikat pisano obavijestio poslodavca o imenovanju sindikalnog povjerenika) na način i pod uvjetima propisanim Zakonom o radu, no nije vezan njihovim mišljenjem te Pravilnik o radu i izmjene/dopune istoga može donijeti unatoč njihovom protivljenju. </p>
    <p>Zakon o radu obvezuje poslodavca da je prije stupanja radnika na rad, radniku omogući da se upozna s propisima u vezi s radnim odnosima te da upozna radnika s organizacijom rada odnosno s odredbama pravilnika o radu, koji mora na prikladan način biti dostupan radnicima, odnosno mora biti objavljen (navedena odredba nalazi se u primjerima ugovora o radu unutar ove aplikacije).</p>
    <p>Prilikom objave pravilnika o radu, poslodavac je dužan pridržavati se odredbi Pravilnika o načinu objave pravilnika o radu, prema kojemu je dužan pravilnik o radu objaviti na način da bude dostupan na uvid radnicima i izložen na vidljivom mjestu u prostorijama u kojima oni redovito borave tijekom radnog dana odnosno na internim mrežnim stranicama, no i dostavom elektroničkom poštom na zahtjev radnika.</p>
    <h5><strong>SVRHA</strong></h5>
    <p>Osim ispunjenja zakonske forme i usklađenja sa zakonom odnosno uređivanja važnih pitanja u odnosu poslodavca i radnika, pravilnikom o radu korisno je propisati i razloge za otkaz (redovni, izvanredni) kao i definirati način dostave otkaza, način uručenja upozorenja pred otkaz, itd..</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Neusvajanje, neobjava pravilnika o radu odnosno manjkav sadržaj pravilnika o radu</strong></p>
    <p>Pojašnjenje: poslodavac čini prekršaj ako ne donese ili ne objavi pravilnik o radu odnosno ako pravilnikom o radu ne uredi pitanja koja pravilnikom moraju biti uređena. </p>
    <p><strong>- Neselektivno i obimno preuzimanje odredbi zakona o radu u pravilnik o radu</strong></p>
    <p>Pojašnjenje: time pravilnik praktički beskoristan dokument te kompliciran za tumačenje, jer se svaka odredba mora uspoređivati sa Zakonom o radu, kako bi se utvrdilo za radnika najpovoljnije pravo.     </p>
    <p><strong>- Nesavjetovanje s radničkim vijećem / sindikalnim povjerenikom prije donošenja pravilnika o radu </strong></p>
    <p>Pojašnjenje: poslodavac čini teži prekršaj ako donese pravilnik o radu bez savjetovanja s radničkim vijećem.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o radu, Pravilnik o načinu objave pravilnika o radu.</p>
  `,

  sides: [
    {
        signature: 'Za Poslodavca',
        inputs: [{
            type: "input",
            required: true,
            placeholder: "Poslovni subjekt",
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto",
          },
          {
            type: "input",
            required: true,
            placeholder: "OIB",
          },
          {
            type: "input",
            placeholder: "Zastupa",
            inSignature: true,
          },
          {
            type: "input",
            placeholder: "Funkcija",
            inSignature: true,
          }],
        suffix: ' (u daljnjem tekstu: Poslodavac),',
    }
],

headline: '​donosi sljedeći',
title: 'PRAVILNIK O RADU',


articles: [
    
    {
        title: 'I. TEMELJNE ODREDBE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ovim Pravilnikom o radu (u daljnjem tekstu: Pravilnik) uređuju se radni odnosi, odnosno prava i obveze koja iz tih odnosa nastaju, kako za radnika tako i za Poslodavca.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ako je neko pravo iz radnog odnosa različito uređeno ugovorom o radu, ovim Pravilnikom, sporazumom sklopljenim između Radničkog vijeća i Poslodavca, kolektivnim ugovorom ili zakonom, primjenjuje se za radnika najpovoljnije pravo, ako zakonom nije drukčije određeno.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac je obvezan u radnom odnosu radniku dati posao te mu za obavljeni rad isplatiti plaću, a radnik je obvezan prema uputama Poslodavca danim u skladu s naravi i vrstom rada, osobno obavljati preuzeti posao. \r\n(2) Pod pojmom radnika podrazumijeva se svaka fizička osoba, bez obzira na spol, koja u radnom odnosu obavlja posao za Poslodavca. \r\n(3) Ovaj Pravilnik odnosi se i na zaposlene na radnim mjestima s posebnim ovlastima i odgovornostima (menadžerski ugovori).',
            },
        ],
    },
    {
        title: 'II. ZAŠTITA ŽIVOTA, ZDRAVLJA I PRIVATNOSTI RADNIKA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac je dužan pribaviti i održavati postrojenja, uređaje, opremu, alate, mjesto rada i pristup mjestu rada, te organizirati rad na način koji osigurava zaštitu života i zdravlja radnika, u skladu s posebnim zakonima i drugim propisima i naravi posla koji se obavlja.\r\n(2) Poslodavac je dužan upoznati radnika s opasnostima posla kojeg radnik obavlja, a dužan ga je i osposobiti za rad, na način koji osigurava zaštitu života i zdravlja radnika te sprječava nastanak nesreća.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Osobni podaci radnika smiju se prikupljati, obrađivati, koristiti i dostavljati trećim osobama samo ako je to dopušteno zakonom ili drugim propisom koji obvezuje Poslodavca (Uredba EU i sl.) ili ako je to potrebno radi ostvarivanja prava i obveza iz radnog odnosa, odnosno u vezi s radnim odnosom ili ako se temelji na privolama danim na temelju Uredbe EU. \r\n(2) Osobni podaci su svi podaci koji se odnose na pojedinca čiji je identitet utvrđen ili se može utvrditi. Pojedinac čiji se identitet može utvrditi jest osoba koja se može identificirati izravno ili neizravno, osobito uz pomoć identifikatora kao što su ime, identifikacijski broj, podaci o lokaciji, mrežni identifikator ili uz pomoć jednog ili više čimbenika svojstvenih za fizički, fiziološki, genetski, mentalni, ekonomski, kulturni ili socijalni identitet tog pojedinca.\r\n(3) U radnom odnosu se takvi podaci mogu odnositi na ime i prezime, OIB, telefonski broj, datum rođenja, broj bankovnog računa, podatke koji su potrebni za prijavu/odjavu radnika tijelima osiguranja (HZZO,HZMO) te ispunjenje ostalih zakonskih obveza Poslodavca u odnosu na obračun plaće i ostvarivanje ostalih prava radnika, ispunjenje obveza iz Zaštite na radu/Zaštite od požara, vođenje evidencija o radnicima sukladno Pravilniku o sadržaju i načinu vođenja evidencije o radnicima i sl..\r\n(4) Osobne podatke radnika Poslodavac smije obrađivati isključivo u skladu s  Općom uredom o zaštiti podataka (Uredba EU 2016/679). \r\n(5) Poslodavac će posebnom odlukom imenovati osobu koja mora uživati povjerenje radnika i koja je osim njega ovlaštena nadzirati prikupljaju li se, obrađuju, koriste i dostavljaju trećim osobama osobni podaci u skladu sa zakonom.',
            },
        ],
    },
    {
        title: 'III. PRIPRAVNICI',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Pripravnik se za samostalan rad osposobljava pod nadzorom mentora kojeg mu odredi Poslodavac.\r\n(2) Za trajanja pripravničkog staža pripravnik će obavljati sve poslove iz djelokruga poslova za koje se priprema.\r\n(3) Radi osposobljavanja za samostalan rad, pripravnika se može privremeno uputiti na rad kod drugog poslodavca.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Osposobljavanje pripravnika za samostalan rad (pripravnički staž) traje najduže godinu dana, ako zakonom nije drukčije određeno.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Nakon što završi pripravnički staž, pripravnik polaže stručni ispit. \r\n(2) Stručni ispit se polaže pred ispitnim povjerenstvom od 3 (tri) člana kojeg odredi Poslodavac. \r\n(3) Predsjednik ispitnog povjerenstva je pripravnikov mentor. \r\n(4) Ispitno povjerenstvo ocjenjuje je li pripravnik položio ili nije položio stručni ispit. \r\n(5) Pripravniku koji ne položi stručni ispit Poslodavac može redovito otkazati ugovor o radu.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ako je stručni ispit ili radno iskustvo, zakonom ili drugim propisom utvrđeno kao uvjet za obavljanje poslova radnog mjesta određenog zanimanja, Poslodavac može osobu koja je završila školovanje za takvo zanimanje primiti na stručno osposobljavanje za rad bez zasnivanja radnog odnosa (stručno osposobljavanje za rad). \r\n(2) Razdoblje stručnog osposobljavanja za rad iz stavka 1. ovoga članka ubraja se u pripravnički staž i radno iskustvo propisano kao uvjet za rad na poslovima radnog mjesta određenog zanimanja. \r\n(3) Stručno osposobljavanje za rad iz stavka 1. ovoga članka može trajati najduže koliko traje pripravnički staž. \r\n(4) Ako Zakonom o radu ili drugim zakonom nije drukčije propisano, na osobu koja se stručno osposobljava za rad, primjenjuju se odredbe o radnim odnosima toga i drugih zakona, osim odredbi o sklapanju ugovora o radu, plaći i naknadi plaće te prestanku ugovora o radu. \r\n(5) Ugovor o stručnom osposobljavanju za rad mora se sklopiti u pisanom obliku.                ',
            },
        ],
    },

    {
        title: 'IV. RADNO VRIJEME',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radno vrijeme (pojam radnog vremena, puno radno vrijeme, nepuno radno vrijeme, uvjeti rada radnika koji rade u nepunom radnom vremenu, skraćeno radno vrijeme, prekovremeni rad, raspored radnog vremena, preraspodjela radnog vremena, zaštita posebno osjetljivih skupina, noćni rad, zabrana noćnog rada, rad u smjenama, obveze poslodavca prema noćnim i smjenskim radnicima) propisano je odredbama Zakona o radu, ovog Pravilnika odnosno pisanom odlukom Poslodavca. \r\n(2) Rad treba započeti na vrijeme i ne smije se prije utvrđenog kraja radnog vremena završiti.\r\n(3) O odrađenim satima rada Poslodavac vodi posebnu evidenciju. \r\n(4) Odrađeni sati rada evidentiraju se jednoobrazno i na tipskom obrascu u svim organizacijskim jedinicama Poslodavca. \r\n(5) Evidenciju odrađenih sati vodi ovlaštena osoba koju odredi nadležni voditelj organizacijske jedinice.',
            },
        ],
    },
    {
        title: 'V. ODMORI I DOPUSTI; Stanka, dnevni odmor i tjedni odmor',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Stanka, dnevni i tjedni odmor propisani su odredbama Zakona o radu, ovim Pravilnikom, odnosno pisanom odlukom Poslodavca. \r\n(2) Radnik koji radi najmanje 6 (šest) sati dnevno, ima svakoga radnog dana pravo na odmor (stanku) od najmanje 30 (trideset) minuta. Maloljetni radnik koji radi najmanje četiri i pol sata dnevno ima svakoga radnog dana pravo na odmor (stanku) od najmanje 30 minuta neprekidno. \r\n(3) Vrijeme odmora iz prethodnog stavka ovog članka ubraja se u radno vrijeme.',
            },
        ],
    },
    {
        title: 'Godišnji odmor',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik ima pravo na plaćeni godišnji odmor za svaku kalendarsku godinu.',
            },
        ],
    },
    {
        title: 'Trajanje godišnjeg odmora',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik ima za svaku kalendarsku godinu pravo na godišnji odmor od najmanje četiri tjedna, a maloljetnik i radnik koji radi na poslovima na kojima, uz primjenu mjera zaštite zdravlja i sigurnosti na radu, nije moguće zaštititi radnika od štetnih utjecaja u trajanju od najmanje pet tjedana. ',
            },
        ],
    },
    {
        title: 'Razmjerni dio godišnjeg odmora',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik koji nije ispunio uvjet za stjecanje prava na godišnji odmor na način propisan prethodnim člankom ovog Pravilnika te Zakonom o radu, ima pravo na razmjeran dio godišnjeg odmora, koji se utvrđuje u trajanju od jedne dvanaestine godišnjeg odmora iz prethodnog članka ovog Pravilnika, za svaki mjesec trajanja radnog odnosa.\r\n(2) Iznimno od prethodnog članka ovog Pravilnika i važeće odredbe Zakona o radu, radnik kojem prestaje radni odnos, za tu kalendarsku godinu ostvaruje pravo na razmjeran dio godišnjeg odmora. \r\n(3) Poslodavac koji je radniku iz prethodnog stavka ovog članka, prije prestanka radnog odnosa omogućio korištenje godišnjeg odmora u trajanju dužem od onog koji bi mu pripadao, nema pravo od radnika tražiti vraćanje naknade plaće isplaćene za korištenje godišnjeg odmora.',
            },
        ],
    },
    {
        title: 'Utvrđivanje godišnjeg odmora',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Godišnji odmor iz prethodna dva članka ovog Pravilnika, utvrđuje se brojem radnih dana ovisno o radnikovom tjednom rasporedu radnog vremena. \r\n(2) Blagdani i neradni dani određeni zakonom, razdoblje privremene nesposobnosti za rad koje je utvrdio ovlašteni liječnik te dani plaćenog dopusta, ne uračunavaju se u trajanje godišnjeg odmora. \r\n(3) Iznimno od odredbe prethodnog stavka ovog članka, ako bi po rasporedu radnog vremena radnik na dan blagdana ili neradnog dana određenog zakonom trebao raditi, a toga dana na svoj zahtjev koristi godišnji odmor, u trajanje godišnjeg odmora uračunava se i taj dan. \r\n(4) Pri izračunavanju trajanja godišnjeg odmora na način iz prethodnog članka ovog Pravilnika, najmanje polovica dana godišnjeg odmora zaokružuje se na cijeli dan godišnjeg odmora, a najmanje polovica mjeseca rada zaokružuje se na cijeli mjesec. \r\n(5) Kad radniku radni odnos prestaje točno u polovici mjeseca koji ima parni broj dana, pravo na jednu dvanaestinu godišnjeg odmora za taj mjesec ostvaruje kod poslodavca kod kojeg mu prestaje radni odnos.',
            },
        ],
    },
    {
        title: 'Ništetnost odricanja od prava na godišnji odmor',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ništetan je sporazum o odricanju od prava na godišnji odmor, odnosno o isplati naknade umjesto korištenja godišnjeg odmora.',
            },
        ],
    },
    {
        title: 'Naknada plaće za vrijeme godišnjeg odmora',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Za vrijeme korištenja godišnjeg odmora radnik ima pravo na naknadu plaće u iznosu određenom kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu, a najmanje u visini njegove prosječne mjesečne plaće u prethodna tri mjeseca (uračunavajući sva primanja u novcu i naravi koja predstavljaju naknadu za rad).',
            },
        ],
    },
    {
        title: 'Naknada za neiskorišteni godišnji odmor',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) U slučaju prestanka ugovora o radu Poslodavac je dužan radniku koji nije iskoristio godišnji odmor isplatiti naknadu umjesto korištenja godišnjeg odmora.\r\n(2) Naknada iz stavka 1. ovog članka određuje se razmjerno broju dana neiskorištenoga godišnjeg odmora.',
            },
        ],
    },
    {
        title: 'Korištenje godišnjeg odmora u dijelovima',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ako radnik koristi godišnji odmor u dijelovima, mora tijekom kalendarske godine za koju ostvaruje pravo na godišnji odmor iskoristi najmanje dva tjedna u neprekidnom trajanju, osim ako se radnik i Poslodavac drukčije ne dogovore, pod uvjetom da je ostvario pravo na godišnji odmor u trajanju dužem od dva tjedna.',
            },
        ],
    },
    {
        title: 'Prenošenje godišnjeg odmora u sljedeću kalendarsku godinu',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Neiskorišteni dio godišnjeg odmora u trajanju dužem od dijela godišnjeg odmora iz prethodnog članka ovog Pravilnika radnik može prenijeti i iskoristiti najkasnije do 30. lipnja sljedeće kalendarske godine. \r\n (2) Radnik koji je ostvario pravo na razmjerni dio godišnjeg odmora u trajanju kraćem od dijela godišnjeg odmora iz prethodnog članka ovog Pravilnika, može taj dio godišnjeg odmora prenijeti i iskoristiti najkasnije do 30. lipnja sljedeće kalendarske godine. \r\n(3) Radnik ne može prenijeti u sljedeću kalendarsku godinu dio godišnjeg odmora iz prethodnog članka ovog Pravilnika ako mu je bilo omogućeno korištenje toga odmora. \r\n(4) Godišnji odmor, odnosno dio godišnjeg odmora koji je prekinut ili nije korišten u kalendarskoj godini u kojoj je stečen, zbog bolesti te korištenja prava na rodiljni, roditeljski i posvojiteljski dopust te dopust radi skrbi i njege djeteta s težim smetnjama u razvoju, radnik ima pravo iskoristiti po povratku na rad, a najkasnije do 30. lipnja sljedeće kalendarske godine. \r\n(5) Iznimno od prethodnog stavka ovog članka, godišnji odmor, odnosno dio godišnjeg odmora koji radnik zbog korištenja prava na rodiljni, roditeljski i posvojiteljski dopust te dopust radi skrbi i njege djeteta s težim smetnjama u razvoju nije mogao iskoristiti ili njegovo korištenje Poslodavac nije omogućio do 30. lipnja sljedeće kalendarske godine, radnik ima pravo iskoristiti do kraja kalendarske godine u kojoj se vratio na rad. \r\n(6) Radnik na radu u inozemstvu ili radnik koji je vršio dužnost i prava državljana u obrani, može godišnji odmor u cijelosti iskoristiti u sljedećoj kalendarskoj godini.',
            },
        ],
    },
    {
        title: 'Raspored korištenja godišnjeg odmora',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Raspored korištenja godišnjeg odmora utvrđuje Poslodavac Odlukom, a u skladu s ovim Pravilnikom. \r\n(2) Radniku koji radi u nepunom radnom vremenu kod dva ili kod više Poslodavaca, a poslodavci ne postignu sporazum o istodobnom korištenju godišnjeg odmora, dužni su mu omogućiti korištenje godišnjeg odmora prema njegovu zahtjevu. \r\n(3) Poslodavac prijedlog rasporeda korištenja godišnjeg odmora sastavlja na temelju zamolbi radnika. Nakon što se o planu godišnjeg odmora savjetuje sukladno odredbama Zakona o radu, Poslodavac utvrđuje plan godišnjih odmora te o istome obavještava radnike Odlukom o rasporedu korištenja godišnjeg odmora pridržavajući se pri tome zakonskog roka za utvrđivanje rasporeda korištenja godišnjeg odmora. \r\n(4) Pri utvrđivanju rasporeda korištenja godišnjeg odmora moraju se uzeti u obzir potrebe organizacije rada te mogućnosti za odmor raspoložive radnicima. \r\n(5) Radnika se mora u roku određenom Zakonom o radu obavijestiti o trajanju godišnjeg odmora i razdoblju njegovog korištenja. \r\n(6) Jedan dan godišnjeg odmora radnik ima pravo, uz obvezu da o tome obavijesti poslodavca najmanje tri dana prije njegova korištenja, koristiti kada on to želi, osim ako posebno opravdani razlozi na strani poslodavca to onemogućuju.',
            },
        ],
    },
    {
        title: 'Plaćeni dopust',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Tijekom kalendarske godine radnik ima pravo na oslobođenje od obveze rada uz naknadu plaće (plaćeni dopust), za važne osobne potrebe, a osobito za: \r\n- sklapanje braka 2 radna dana,  \r\n- rođenje djeteta 2 radna dana,  \r\n- smrt člana uže obitelji 2 radna dana, \r\n- teške bolesti člana uže obitelji 2 radna dana. \r\n(2) Radnik ima pravo na dopust iz stavka 1. ovog članka u ukupnom trajanju od sedam radnih dana godišnje, ako to nije drukčije uređeno kolektivnim ugovorom ili ugovorom o radu.\r\n(3) Članom uže obitelji iz prethodnog stavka smatraju se: supružnik, srodnici po krvi u pravoj liniji i njihovi supružnici, braća i sestre, pastorčad i posvojenici, djeca povjerena na čuvanje i odgoj ili djeca na skrbi izvan vlastite obitelji, očuh i maćeha, posvojitelj i osoba koju je radnik dužan po zakonu uzdržavati te osoba koja s radnikom živi u izvanbračnoj zajednici. ',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik ima pravo na plaćeni dopust za vrijeme obrazovanja ili stručnog osposobljavanja i usavršavanja te obrazovanja za potrebe radničkog vijeća ili sindikalnog rada. \r\n(2) Pravo iz prethodnog stavka ovog članka, vezano uz obrazovanje za potrebe radničkog vijeća ili sindikalnog rada radnik koji je član radničkog vijeća ili sindikalni povjerenik ostvaruje u trajanju do 3 (tri) dana u jednoj kalendarskoj godini.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Za stjecanje prava iz radnog odnosa ili u vezi s radnim odnosom, razdoblja plaćenog dopusta smatraju se vremenom provedenim na radu.',
            },
        ],
    },
    {
        title: 'Neplaćeni dopust',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može radniku na njegov zahtjev odobriti neplaćeni dopust. \r\n(2) Za vrijeme neplaćenog dopusta prava i obveze iz radnog odnosa ili u svezi s radnim odnosom miruju, ako zakonom nije drukčije određeno.',
            },
        ],
    },
    {
        title: 'VI. ZAŠTITA TRUDNICA, RODITELJA I POSVOJITELJA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac ne smije odbiti zaposliti ženu zbog njezine trudnoće, niti joj zbog trudnoće, rođenja ili dojenja djeteta u smislu posebnog propisa smije ponuditi sklapanje izmijenjenog ugovora o radu pod nepovoljnijim uvjetima. \r\n(2) Poslodavac ne smije tražiti bilo kakve podatke o trudnoći niti smije uputiti drugu osobu da ih traži, osim ako radnica osobno zahtijeva određeno pravo predviđeno zakonom ili drugim propisom radi zaštite trudnica.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Trudnoj radnici, radnici koja je rodila ili radnici koja doji dijete u smislu posebnog propisa, a koja radi na poslovima koji ugrožavaju njezin život ili zdravlje, odnosno djetetov život ili zdravlje, Poslodavac je dužan za vrijeme korištenja prava u skladu s posebnim propisom, ponuditi dodatak ugovora o radu kojim će se na određeno vrijeme ugovoriti obavljanje drugih odgovarajućih poslova. \r\n(2) U sporu između poslodavca i radnice samo je doktor specijalist medicine rada nadležan ocijeniti jesu li poslovi na kojima radnica radi, odnosno drugi ponuđeni poslovi u slučaju iz stavka 1. ovog članka odgovarajući. \r\n(3) Ako Poslodavac nije u mogućnosti postupiti na način propisan stavkom 1. ovog članka, radnica ima pravo na dopust u skladu s posebnim propisom. \r\n(4) Prestankom korištenja prava u skladu s posebnim propisom, prestaje dodatak iz stavka 1. ovog članka te radnica nastavlja obavljati poslove na kojima je prethodno radila na temelju ugovora o radu. \r\n(5) Dodatak ugovora o radu iz stavka 1. ovog članka, ne smije imati za posljedicu smanjenje plaće radnice.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ako je za stjecanje određenih prava iz radnog odnosa ili u vezi s radnim odnosom važno prethodno trajanje radnog odnosa, razdoblja rodiljnog, roditeljskog, posvojiteljskog dopusta, rada s polovicom punog radnog vremena, rada s polovicom punog radnog vremena radi pojačane brige i njege djeteta, dopusta trudnice ili majke koja doji dijete, te dopusta ili rada s polovicom punog radnog vremena radi brige i njege djeteta s težim smetnjama u razvoju, smatrat će se vremenom provedenim na radu u punom radnom vremenu. \r\n(2) Rodiljna i roditeljska prava radnik tijekom radnog odnosa ostvaruje u skladu s posebnim propisom.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Za vrijeme trudnoće, korištenja rodiljnog, roditeljskog, posvojiteljskog dopusta, rada s polovicom punog radnog vremena, rada s polovicom punog radnog vremena radi pojačane brige i njege djeteta, dopusta trudnice ili majke koja doji dijete, te dopusta ili rada s polovicom punog radnog vremena radi brige i njege djeteta s težim smetnjama u razvoju, odnosno u roku od petnaest dana od prestanka trudnoće ili prestanka korištenja tih prava, Poslodavac ne smije otkazati ugovor o radu trudnici i osobi koja se koristi nekim od tih prava.\r\n(2) Otkaz iz stavka 1. ovog članka je ništetan, ako je na dan davanja otkaza Poslodavcu bilo poznato postojanje okolnosti iz stavka 1. ovog članka ili ako radnik u roku od petnaest dana od dostave otkaza obavijesti Poslodavca o postojanju okolnosti iz stavka 1. ovog članka te o tome dostavi odgovarajuću potvrdu ovlaštenog liječnika ili drugog ovlaštenog tijela. \r\n(3) Ugovor o radu osobe iz stavka 1. ovog članka, prestaje smrću poslodavca fizičke osobe, prestankom obrta po sili zakona ili brisanjem trgovca pojedinca iz registra. \r\n(4) Ugovor o radu osobe iz stavka 1. ovog članka, tijekom provedbe postupka likvidacije u skladu s posebnim propisom, može se otkazati zbog poslovno uvjetovanih razloga.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik koji koristi pravo na rodiljni, roditeljski i posvojiteljski dopust, rad s polovicom punog radnog vremena, rad s polovicom punog radnog vremena radi pojačane njege djeteta, dopust trudnice ili majke koja doji dijete, te dopust ili rad s polovicom punog radnog vremena radi brige i njege djeteta s težim smetnjama u razvoju ili kojem ugovor o radu miruje do treće godine života djeteta u skladu s posebnim propisom, može otkazati ugovor o radu izvanrednim otkazom. \r\n(2) Na način iz stavka 1. ovog članka, ugovor o radu može se otkazati najkasnije petnaest dana prije dana na koji je Radnik dužan vratiti se na rad. \r\n(3) Trudnica može otkazati ugovor o radu izvanrednim otkazom.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Nakon isteka rodiljnog, roditeljskog, posvojiteljskog dopusta, dopusta radi skrbi i njege djeteta s težim smetnjama u razvoju te mirovanja radnog odnosa do treće godine života djeteta u skladu s posebnim propisom, radnik koji je koristio neko od tih prava ima pravo povratka na poslove na kojima je radio prije korištenja toga prava, u roku od mjesec dana od dana kada je poslodavca obavijestio o prestanku korištenja toga prava. \r\n(2) Ako je prestala potreba za obavljanjem poslova koje je radnik obavljao prije korištenja prava iz stavka 1. ovog članka, Poslodavac mu je dužan ponuditi sklapanje ugovora o radu za obavljanje drugih odgovarajućih poslova, čiji uvjeti rada ne smiju biti nepovoljniji od uvjeta rada poslova koje je obavljao prije korištenja toga prava. \r\n(3) Radnik koji se koristio pravom iz stavka 1. ovog članka, ima pravo na dodatno stručno osposobljavanje ako je došlo do promjene u tehnici ili načinu rada, kao i sve druge pogodnosti koje proizlaze iz poboljšanih uvjeta rada na koje bi imao pravo.',
            },
        ],
    },
    {
        title: 'VII. ZAŠTITA RADNIKA KOJI SU PRIVREMENO ILI TRAJNO NESPOSOBNI ZA RAD',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik je dužan, što je moguće prije, obavijestiti poslodavca o privremenoj nesposobnosti za rad, a najkasnije u roku od tri dana dužan mu je dostaviti liječničku potvrdu o privremenoj nesposobnosti za rad i njezinu očekivanom trajanju. \r\n(2) Ovlašteni liječnik dužan je radniku izdati potvrdu iz stavka 1. ovog članka. \r\n(3) Ako zbog opravdanog razloga radnik nije mogao ispuniti obvezu iz stavka 1. ovog članka, dužan je to učiniti što je moguće prije, a najkasnije u roku od tri dana od dana prestanka razloga koji ga je u tome onemogućavao.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radniku koji je pretrpio ozljedu na radu ili je obolio od profesionalne bolesti, za vrijeme privremene nesposobnosti za rad tijekom liječenja ili oporavka od ozljede na radu ili profesionalne bolesti, Poslodavac ne može otkazati ugovor o radu. \r\n(2) Zabrana iz stavka 1. ovog članka ne utječe na prestanak ugovora o radu sklopljenoga na određeno vrijeme.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik koji je privremeno bio nesposoban za rad zbog ozljede ili ozljede na radu, bolesti ili profesionalne bolesti, a za kojega nakon liječenja, odnosno oporavka, ovlašteni liječnik, odnosno ovlašteno tijelo u skladu s posebnim propisom utvrdi da je sposoban za rad, ima pravo vratiti se na poslove na kojima je prethodno radio. \r\n(2) Ako je prestala potreba za obavljanjem poslova na kojima je radnik prethodno radio, Poslodavac mu je dužan ponuditi sklapanje ugovora o radu za obavljanje drugih odgovarajućih poslova, koji moraju, što je više moguće odgovarati poslovima na kojima je radnik prethodno radio. \r\n(3) Ako Poslodavac nije u mogućnosti radniku ponuditi sklapanje ugovora o radu za obavljanje drugih odgovarajućih poslova ili ako radnik odbije ponuđenu izmjenu ugovora o radu, Poslodavac mu može otkazati ugovor o radu na način i pod uvjetima propisanim određenim Zakonom o radu i ovim Pravilnikom. \r\n(4) U sporu između Poslodavca i radnika, samo je doktor specijalist medicine rada nadležan ocijeniti jesu li ponuđeni poslovi iz stavka 2. ovog članka odgovarajući. \r\n(5) Radnik iz stavka 1. ovog članka ima pravo na dodatno stručno osposobljavanje, ako je došlo do promjene u tehnologiji ili načinu rada, kao i na sve druge pogodnosti koje proizlaze iz poboljšanih uvjeta rada na koje bi imao pravo.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ako kod radnika postoji smanjenje radne sposobnosti uz preostalu radnu sposobnost, smanjenje radne sposobnosti uz djelomični gubitak radne sposobnosti ili neposredna opasnost od nastanka smanjenja radne sposobnosti koju je utvrdilo ovlašteno tijelo u skladu s posebnim propisom, Poslodavac je dužan, uzimajući u obzir nalaz i mišljenje toga tijela, ponuditi radniku sklapanje ugovora o radu za obavljanje poslova za koje je radno sposoban, koji moraju, što je više moguće odgovarati poslovima na kojima je radnik prethodno radio. \r\n(2) Radi osiguranja poslova iz stavka 1. ovog članka, Poslodavac je dužan prilagoditi poslove sposobnostima radnika, izmijeniti raspored radnog vremena, odnosno poduzeti druge mjere da radniku osigura odgovarajuće poslove. \r\n(3) Ako je Poslodavac poduzeo sve mjere iz stavka 2. ovog članka, a ne može radniku osigurati odgovarajuće poslove, odnosno ako je radnik odbio ponudu za sklapanje ugovora o radu za obavljanje poslova koji odgovaraju njegovim sposobnostima u skladu s nalazom i mišljenjem ovlaštenog tijela, Poslodavac radniku može otkazati ugovor o radu uz suglasnost radničkog vijeća. \r\n(4) U sporu između poslodavca i radnika, samo je doktor specijalist medicine rada nadležan ocijeniti jesu li ponuđeni poslovi iz stavka 1. ovog članka odgovarajući. \r\n(5) Ako radničko vijeće uskrati suglasnost na otkaz radniku iz stavka 1. ovog članka, suglasnost može nadomjestiti arbitražna odluka.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik koji je pretrpio ozljedu na radu, odnosno koji je obolio od profesionalne bolesti, a kojemu nakon završenog liječenja, oporavka i profesionalne rehabilitacije, Poslodavac ne može osigurati odgovarajuće poslove iz prethodnog članka ovog Pravilnika o radu, ima pravo na otpremninu najmanje u dvostrukom iznosu, ako je ispunio uvjete za stjecanje prava na otpremninu. \r\n(2) Radnik iz stavka 1. ovog članka, koji je neopravdano odbio ponuđene poslove iz prethodnog članka ovog Pravilnika o radu, nema pravo na otpremninu u dvostrukom iznosu. ',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik koji je pretrpio ozljedu na radu ili je obolio od profesionalne bolesti ima prednost pri stručnom osposobljavanju i školovanju koje organizira Poslodavac.',
            },
        ],
    },
    {
        title: 'VIII. PLAĆE I NAKNADE PLAĆE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac je dužan radniku za njegov rad isplatiti plaću koja se sastoji od: \r\n- osnovne plaće utvrđene po osnovi složenosti i odgovornosti poslova na koje je radnik raspoređen i normalnih uvjeta rada na dotičnim poslovima, \r\n- povećane plaće, \r\n- stimulativnog dijela, pod uvjetima određenim kolektivnim ugovorom, ugovorom o radu odnosno ovim Pravilnikom.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac će u ugovoru o radu sa svakim radnikom pojedinačno definirati primjeren iznos osnovne plaće odnosno pozvati se na platni razred određen Pravilnikom o organizaciji rada i sistematizaciji radnih mjesta. Na taj način utvrđena osnovna plaća ne smije biti u manjem iznosu od onoga koji je utvrđen na temelju Zakona o minimalnoj plaći.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može svim ili pojedinim radnicima isplatiti stimulativni dio plaće ovisno o rezultatima poslovanja ili zalaganju.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Plaća pripravnika iznosi 70% od plaće radnog mjesta za koje se pripravnik osposobljava.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ako kolektivnim ugovorom ili ugovorom o radu nije drukčije određeno, plaća i naknada plaće se za prethodni mjesec isplaćuju najkasnije do zadnjeg dana u mjesecu za prethodni mjesec.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac je dužan isprave o plaći, naknadi plaće i otpremnine radniku dostaviti sukladno odrebama Zakonu o radu. \r\n(2) Obračuni iz prethodnog stavka su ovršne isprave.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                help: "Navedeni postoci povećanja plaće nisu propisani Zakonom o radu ili bilo kojim drugim propisom, stoga poslodavac samostalno određuje iznose povećanja plaće iz ovog članka.",
                content: '(1) Za otežane uvjete rada, prekovremeni i noćni rad te za rad nedjeljom, blagdanom ili nekim drugim danom za koji je zakonom određeno da se ne radi radnik ima pravo na povećanu plaću i to: \r\n- za otežane uvjete rada 30%, \r\n- za noćni rad 50%, \r\n- za prekovremeni rad 30%, \r\n- za rad nedjeljom 50%, \r\n- za rad blagdanom ili nekim drugim danom za koji je zakonom određeno da se ne radi 30%. \r\n(2) Ukoliko se rad radnika obavlja uz istodobno prisustvo više posebnih uvjeta, dodaci se kumuliraju, osim ako je blagdan ili neradni dan utvrđen zakonom, nedjelja. ',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Za razdoblja u kojima ne radi zbog opravdanih razloga određenih zakonom, drugim propisom ili kolektivnim ugovorom (npr. zbog godišnjeg odmora, obrazovanja za potrebe poslodavca, plaćenog dopusta, zastoja u proizvodnji kojeg nije skrivio radnik i sl.), radnik ima pravo na naknadu plaće. \r\n(2) Ako nije drukčije određeno zakonom, drugim propisom, kolektivnim ugovorom ili ugovorom o radu, radnik ima pravo na naknadu plaće u visini prosječne plaće isplaćene mu u prethodna 3 (tri) mjeseca.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik koji je privremeno nesposoban za rad, za vrijeme bolovanja koje se obračunava na teret Poslodavca, ima pravo na naknadu u iznosu od 70% plaće koju je ostvario u prethodnom mjesecu.\r\n(2) Ukoliko je privremena nesposobnost za rad uzrokovana ozljedom na radu odnosno profesionalnom bolešću, radniku pripada naknada u iznosu 100% plaće koju bi ostvario da je radio.',
            },
        ],
    },
    {
        title: 'IX. MATERIJALNA PRAVA RADNIKA; Naknada troškova prijevoza na posao i s posla',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može radniku isplatiti naknadu troškova prijevoza na posao i s posla u visini troškova javnim prijevozom koji je najjeftiniji za poslodavca, s tim da je maksimalni iznos naknade na koju radnik ima pravo do 1.000,00 kn. \r\n(2) Ako se radnik ne može koristiti sredstvima javnog prijevoza, ima pravo na naknadu troškova u visini cijene prijevoza koju imaju drugi radnici slične udaljenosti. \r\n(3) Naknada troškova prijevoza na posao i s posla se isplaćuje najkasnije do 30-og u mjesecu za prethodni mjesec. \r\n(4) Radnik kojemu je na korištenje dano službeno vozilo nema pravo na naknadu troškova prijevoza na posao i s posla.  \r\n(5) Pravo na isplatu naknade troškova prijevoza na posao i s posla, kao i iznos, Poslodavac uređuje zasebnom odlukom.',
            },
        ],
    },
    {
        title: 'Prigodne nagrade (božićnica, uskrsnica, regres)',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može radniku isplatiti prigodnu nagradu (božićnicu, uskrsnicu, naknadu za godišnji odmor - regres i sl.). \r\n(2) Pravo na isplatu prigodne naknade, kao i iznos, Poslodavac uređuje zasebnom odlukom.',
            },
        ],
    },
    {
        title: 'Dodatne nagrade',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može radniku isplatiti nagrade za radne rezultate te druge oblike dodatnog nagrađivanja radnika (dodatna plaća, dodatak uz mjesečnu plaću i sl.). \r\n(2) Pravo na isplatu dodatne nagrade, kao i iznos, Poslodavac uređuje zasebnom odlukom.',
            },
        ],
    },
    {
        title: 'Solidarna pomoć',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može isplatiti solidarnu pomoć u sljedećim slučajevima: \r\n- smrt radnika u visini do maksimalno 7.500 kn, \r\n- smrt člana uže obitelji u visini do maksimalno 3.000,00 kn. \r\n(2) Poslodavac može, ako se steknu uvjeti, isplatiti solidarnu pomoć u sljedećim slučajevima:\r\n- teška invalidnost radnika u visini do maksimalno 2.500,00 kn (jednom godišnje), \r\n- privremena spriječenost za rad duža od 90 dana u visini do maksimalno 2.500,00 kn (jednom godišnje).\r\n(3) Teška invalidnost definira se sukladno propisima o mirovinskom i invalidskom osiguranju. \r\n(4) Pomoć u slučajevima iz stavka 1. i 2. ovog članka isplatit će se radniku ili njegovoj obitelji prema odluci Poslodavca. \r\n(5) Pravo na isplatu solidarne pomoći, kao i iznos, Poslodavac uređuje zasebnom odlukom. ',
            },
        ],
    },
    {
        title: 'Dar djetetu do 15 godina starosti',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može djetetu radnika do 15. godina starosti isplatiti (odnosno dati) dar u naravi. \r\n(2) Pravo na isplatu dara djetetu do 15 godina starosti, kao i iznos, Poslodavac uređuje zasebnom odlukom.',
            },
        ],
    },
    {
        title: 'Jubilarne nagrade',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može odlukom odrediti da nakon određenog broja godina neprekidnog rada za istog poslodavca radnik ostvaruje jubilarnu naknadu. \r\n(2) Pravo na jubilarnu nagradu stječe se nakon 10, 15, 20, 25, 30, 35, 40 i svakih narednih 5 godina neprekidnog rada. \r\n(3) Jubilarna nagrada se može odrediti i isplatiti u sljedećim iznosima:\r\n- 10 god. radnog staža- do 1.500,00 kn,\r\n- 15 god. radnog staža- do 2.000,00 kn,\r\n- 20 god. radnog staža- do 2.500,00 kn, \r\n- 25 god. radnog staža- do 3.000,00 kn, \r\n- 30 god. radnog staža- do 3.500,00 kn,\r\n- 35 god. radnog staža- do 4.000,00 kn, \r\n- 40 god. radnog staža i svakih narednih 5 godina - do 5.000,00 kn. \r\n(4) Pravo na isplatu jubilarne nagrade, kao i iznos, Poslodavac uređuje zasebnom odlukom.',
            },
        ],
    },
    {
        title: 'Otpremnina prilikom odlaska u mirovinu',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može radniku isplatiti na otpremninu prilikom odlaska u mirovinu. \r\n(2) Pravo na isplatu otpremnine prilikom odlaska u mirovinu, kao i iznos, Poslodavac uređuje zasebnom odlukom.',
            },
        ],
    },
    {
        title: 'X. ZABRANA NATJECANJA RADNIKA S POSLODAVCEM; Zakonska zabrana natjecanja',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik ne smije bez odobrenja Poslodavca, za svoj ili tuđi račun, sklapati poslove iz djelatnosti koju obavlja Poslodavac. \r\n(2) Ako radnik postupi protivno zabrani iz stavka 1. ovog članka, Poslodavac može od radnika tražiti naknadu pretrpljene štete ili može tražiti da se sklopljeni posao smatra sklopljenim za njegov račun, odnosno da mu radnik preda zaradu ostvarenu iz takvog posla ili da na njega prenese potraživanje zarade iz takvoga posla. \r\n(3) Pravo Poslodavca iz stavka 2. ovog članka prestaje u roku tri mjeseca od dana kada je Poslodavac saznao za sklapanje posla, odnosno pet godina od dana sklapanja posla. \r\n(4) Ako je u vrijeme zasnivanja radnog odnosa Poslodavac znao da se radnik bavi obavljanjem određenih poslova, a nije od njega zahtijevao da se prestane time baviti, smatra se da je radniku dao odobrenje za bavljenje takvim poslovima. \r\n(5) Poslodavac može odobrenje iz stavka 1. odnosno stavka 4. ovog članka opozvati, poštujući pri tome propisani ili ugovoreni rok za otkaz ugovora o radu.',
            },
        ],
    },
    {
        title: 'Ugovorna zabrana natjecanja',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik je dužan pridržavati se zakonske zabrane natjecanja određene Zakonom o radu odnosno ovim Pravilnikom, dok se za pojedine radnike zabrana natjecanja može ugovoriti sukladno odredbama Zakona o radu na način da se određeno vrijeme nakon prestanka ugovora o radu, radnik ne smije zaposliti kod druge osobe koja je u tržišnom natjecanju s poslodavcem te da ne smije za svoj račun ili za račun treće osobe sklapati poslove kojima se natječe s poslodavcem (ugovorna zabrana natjecanja).',
            },
        ],
    },
    {
        title: 'XI. NAKNADA ŠTETE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik koji na radu ili u svezi s radom namjerno ili zbog krajnje nepažnje uzrokuje štetu Poslodavcu, dužan je naknaditi Poslodavcu štetu. \r\n(2) Ako štetu uzrokuje više radnika, svaki radnik odgovara za dio štete koju je uzrokovao. \r\n(3) Ako se za svakog radnika ne može utvrditi dio štete koji je on uzrokovao, smatra se da su svi radnici odgovorni i štetu naknađuju u jednakim dijelovima. \r\n(4) Ako je više radnika uzrokovalo štetu kaznenim djelom počinjenim s namjerom, za štetu odgovaraju solidarno.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Visina štete utvrđuje se na osnovi cjenika ili knjigovodstvene vrijednosti, a ako ovih nema, procjenom. \r\n(2) Procjena visine štete može se povjeriti ovlaštenom sudskom vještaku.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik koji na radu ili u svezi s radom, namjerno ili zbog krajnje nepažnje uzrokuje štetu trećoj osobi, a štetu je naknadio Poslodavac, dužan je Poslodavcu naknaditi iznos naknade isplaćene trećoj osobi.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ako radnik pretrpi štetu na radu ili u svezi s radom, Poslodavac je dužan radniku naknaditi štetu po općim propisima obveznoga prava. \r\n(2) Pravo na naknadu štete iz stavka 1. ovog članka odnosi se i na štetu koju je Poslodavac uzrokovao radniku povredom njegovih prava iz radnog odnosa. ',
            },
        ],
    },
    {
        title: 'XII. POVREDE RADNE OBVEZE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Za povrede/kršenja obveza iz radnog odnosa određene ovim Pravilnikom o radu, Poslodavac ima mogućnost, prema vlastitoj odluci radniku izreći: \r\n- usmenu opomenu, \r\n- pisano upozorenje s mogućnošću otkaza ugovora o radu, \r\n- redoviti otkaz. \r\n(2) Za osobito teške povrede iz radnog odnosa određene ovim Pravilnikom o radu, Poslodavac može radniku  izvanredno otkazati ugovor o radu. \r\n(3) Za povrede/kršenja obveza iz radnog odnosa određene ovim Pravilnikom i za osobito teške povrede iz radnog odnosa može radniku umanjiti plaću, sukladno odredbama ovog Pravilnika.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Usmena opomena i pisano upozorenje su mjere kojima se radnik upozorava na obveze iz radnog odnosa koje su povrijeđene njegovim ponašanjem na radu te mu se ukazuje na mogućnost izricanje teže mjere (otkaza) u slučaju nastavka kršenja istih. \r\n(2) Usmenu opomenu radniku izriče neposredno nadređeni. \r\n(3) O izrečenoj usmenoj opomeni sastavlja se zapisnik u roku od jednog dana od izricanja opomene, a kojeg potpisuje: \r\n- neposredno nadređeni, \r\n- radnik, \r\n- te ostale osobe prisutne prilikom izricanja usmene opomene radniku.\r\n(4) Obavijest i bilješku o izrečenoj usmenoj opomeni obavezno se dostavlja u pravne  i opće poslove i odlaže u dosje radnika. \r\n(5) Pisano upozorenje radniku izriče se na temelju prijedloga direktora organizacijske jedinice.',
            },
        ],
    },
        
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) U slučaju povrede (kršenja) radne obveze određene ovim Pravilnikom, Poslodavac ima pravo umanjiti radniku plaću do 50% iznosa plaće svakog pojedinog radnika utvrđene u skladu s odredbama ovog Pravilnika. \r\n(2) Odluku o sankciji i visinu sankcije donosi i određuje Poslodavac. \r\n(3) Umanjenje plaće ne smatra ustegom plaće niti prijebojem (odluka Županijskog suda u Varaždinu, broj: Gž 1916/05, od 31. siječnja 2005. godine). \r\n(4) Ako je povredema radne obveze uzrokovana i šteta, Poslodavac ima pravo potraživati istu od radnika na temelju odredbama ovog Pravilnika i odredbama obveznog prava.',
            },
        ],
    },
        
    {
        title: 'XIII. PRESTANAK UGOVORA O RADU; Načini prestanka ugovora o radu',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ugovor o radu prestaje:\r\n1. smrću radnika, \r\n2. istekom vremena na koje je sklopljen ugovor o radu na određeno vrijeme, \r\n3. kad radnik navrši 65 godina života i 15 godina mirovinskog staža, osim ako se Poslodavac i radnik drukčije ne dogovore, \r\n4. sporazumom radnika i Poslodavca, \r\n5. dostavom pravomoćnog rješenja o priznanju prava na invalidsku mirovinu zbog opće nesposobnosti za rad, \r\n6. otkazom, \r\n7. odlukom nadležnog suda.',
            },
        ],
    },
        
    {
        title: 'Sporazum o prestanku ugovora o radu',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Sporazum o prestanku ugovora o radu mora biti zaključen u pisanom obliku.',
            },
        ],
    },
        
    {
        title: 'Otkaz ugovora o radu',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ugovor o radu mogu otkazati Poslodavac i radnik.',
            },
        ],
    },
        
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može otkazati ugovor o radu uz propisani ili ugovoreni otkazni rok (redoviti otkaz) ako za to ima opravdani razlog, u slučaju:\r\n- ako prestane potreba za obavljanjem određenog posla zbog gospodarskih, tehnoloških  ili organizacijskih razloga (poslovno uvjetovani otkaz),\r\n- ako radnik nije u mogućnosti uredno izvršavati svoje obveze iz radnog odnosa zbog određenih trajnih osobina ili sposobnosti (osobno uvjetovani otkaz),\r\n- ako radnik krši obveze iz radnog odnosa (otkaz uvjetovan skrivljenim ponašanjem radnika),\r\n- ako radnik nije zadovoljio na probnom radu (otkaz zbog nezadovoljavanja na probnom radu). \r\n(2) Radnik krši obveze iz radnog odnosa u sljedećim slučajevima: \r\n- nekulturno ponašanje u tijeku radnog vremena, \r\n- obavljanje privatnog posla za vrijeme rada, \r\n- neobavještavanje poslodavca o spriječenosti dolaska na rad u roku od 24 sata bez opravdanog razloga, \r\n- neprenošenje radnih iskustava na mlade radnike i pripravnike, \r\n- neopravdani izostanak s rada, \r\n- učestalo kašnjenje na posao, \r\n- izvršenje radnih obveza znatno ispod prosjeka, \r\n- ometanje drugih radnika u radu, \r\n- odbijanje potrebne suradnje s drugim radnicima, \r\n- neispunjenje predviđene norme, \r\n- poduzimanje određene radnje unatoč izričitoj zabrani da se takva radnja poduzme, odnosno nepoduzimanje određene radnje unatoč izričitom nalogu da se određena radnja poduzme, \r\n- vođenje poslova pojedinog organizacijskog dijela Poslodavca, odnosno poduzimanje konkretne radnje koja je dovela do manjka ili viška roba u iznosu koji premašuje uobičajene vrijednosti utvrđene internim propisom, propisima o kalu, rastepu i lomu i sličnim standardima, odnosno koja je dovela do manjka novca ili druge imovine, \r\n- svako nemarno ili nesavjesno izvršavanje poslova i radnih zadataka ili njihovo neizvršavanje u zadanom roku, odnosno svaka druga povreda radne obveze koja je doprinijela nastanku manjka roba, novca ili druge imovine poslodavca, \r\n- zakašnjenje u dolasku na posao, nedopušteni izlazak s posla za vrijeme radnog vremena, ili napuštanje posla prije isteka radnog vremena, \r\n- netočno vođenje evidencije radnog vremena,  \r\n- nestručno rukovanje sredstvima rada, koje je uzrokovalo zastoj u radu, \r\n- neovlašteno korištenje sredstava za rad drugog radnika, \r\n- odbijanje izvršenja radnog zadatka ili postupanje protivno nalogu neposrednog rukovoditelja, \r\n- samovoljni prestanak rada zaposlenika prije isteka otkaznog roka, \r\n- neprijavljivanje ili prikrivanje štete ili štetne radnje, \r\n- lažno prikazivanje ili zatajenje činjenica u svezi s radom, odnosno radnim odnosom u namjeri da sebi ili drugome pribavi materijalnu ili neku drugu korist, \r\n- svako ponašanje prema kupcima, strankama ili drugim osobama koje šteti ugledu Poslodavca, \r\n- svako drugo ponašanje koje predstavlja povredu radne obveze koja je određena Zakonom, Odlukama Poslodavca, općim aktima Poslodavca, sudskom praksom i sl..',
            },
        ],
    }, 
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Pri odlučivanju o poslovno uvjetovanom otkazu, Poslodavac mora voditi računa o trajanju radnog odnosa, starosti i obvezama uzdržavanja koje terete radnika.',
            },
        ],
    },  
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Prije redovitog otkazivanja uvjetovanog ponašanjem radnika, Poslodavac je dužan radnika pisano upozoriti na obvezu iz radnog odnosa i ukazati mu na mogućnost otkaza u slučaju nastavka povrede te obveze, osim ako postoje okolnosti zbog kojih nije opravdano očekivati od poslodavca da to učini. \r\n(2) Prije redovitog ili izvanrednog otkazivanja uvjetovanog ponašanjem radnika, Poslodavac je dužan omogućiti radniku da iznese svoju obranu, osim ako postoje okolnosti zbog kojih nije opravdano očekivati od poslodavca da to učini.',
            },
        ],
    },  
    {
        title: 'Redoviti otkaz radnika',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik može otkazati ugovor o radu uz propisani ili ugovoreni otkazni rok, ne navodeći za to razlog.',
            },
        ],
    },  
    {
        title: 'Izvanredni otkaz ugovora o radu',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac i radnik imaju opravdani razlog za otkaz ugovora o radu sklopljenog na neodređeno ili određeno vrijeme, bez obveze poštivanja propisanog ili ugovorenog otkaznog roka, ako zbog osobito teške povrede obveze iz radnog odnosa ili neke druge osobito važne činjenice, uz uvažavanje svih okolnosti i interesa obiju ugovornih stranaka, nastavak radnog odnosa nije moguć. \r\n(2) Pod osobito teškom povredom obveza iz radnog odnosa prvenstveno se smatra: \r\n- svjesno neizvršavanje obveza iz ugovora o radu, \r\n- nemarno odnosno nekvalitetno obavljanje radnih zadataka, \r\n- neopravdani manjak iznad dopuštene visine rastepa i kala, \r\n- nepravovremeno polaganje utrška po Dnevnom obračunu prodaje, a sukladno internim dokumentima Poslodavca, \r\n- neuredno održavanje odnosno odlaganje dokumentacije, materijala, proizvoda sredstava za rad i sl. \r\n- odbijanje izvršenja povjerenih poslova i radnih zadataka, \r\n- odbijanje rada ili premještaja na druge poslove na temelju naloga Poslodavca, \r\n- neopravdani izostanak s rada više od tri dana tijekom kalendarske godine, \r\n- samovoljni odlazak s radnog mjesta prije kraja radnog vremena ili neopravdano zakašnjenje na rad,  \r\n- izlasci tijekom radnog vremena, bez obavještavanja neposredno nadređenog o razlozima, \r\n- učestalo kršenje pravila rada, \r\n- povreda ili odavanje poslovne tajne, \r\n- narušavanje ugleda Poslodavca ili ostalih radnika iznošenjem ili prenošenjem netočnih podataka u javnost, \r\n- nanošenje štete ugledu Poslodavca, bili pisanim ili usmenim putem, uporabom suvremenih medija komunikacije odnosno bilo kakvim postupanjem protivno internim aktima i pozitivnim propisima RH ili se na drugi način uvredom ili klevetom šteti ugledu Poslodavca, \r\n- iznošenje netočnih podataka koji su bitno utjecali na donošenje poslovne odluke, \r\n- falsificiranje dokumenata Poslodavca, \r\n- izdavanje računa odnosno omogućavanje izdavanja računa za robu koja uopće nije prodana ili nije prodana u vrsti i količini koja je navedena na računu,  \r\n- kvantitativno i/ ili kvalitativno zaprimanje roba suprotno važećim uputama Poslodavca,  \r\n-prodaja robe nekontroliranog porijekla, \r\n- povreda odredaba o osiguranju od eksplozija ili drugih nesreća, \r\n- nepridržavanje odredaba Pravilnika o zaštiti na radu i nekorištenje zaštitnih sredstava, \r\n- nezakonito raspolaganje sredstvima Poslodavca, \r\n- dostava osobnih podataka trećim osobama suprotna odredbama zakona i internih dokumenata Poslodavca,  \r\n- nepridržavanje odredbi Zakona, uputa, odluka, pravilnika i drugih akata Poslodavca, \r\n- organiziranje štrajka, odnosno sudjelovanje u štrajku suprotno zakonom utvrđenim pravilima, \r\n- neprovođenje propisanih mjera zaštite na radu i zaštite od požara zbog kojih su nastupile ili su mogle nastupiti teže posljedice po život i zdravlje radnika i imovine, \r\n- neprijavljivanje počinitelja kaznenih djela izvršenih u vezi s radom kod Poslodavca, \r\n- prikrivanje uočenih nepravilnosti u radu, \r\n- zlouporaba privremene spriječenosti za rad zbog bolesti, \r\n- namjerno sprečavanje ozdravljenja, \r\n- zlouporaba položaja ili prekoračenje ovlasti, \r\n- mijenjanje gotovine za druga sredstva plaćanja (čekovi, kartice), \r\n- krađa, \r\n- otuđivanje (krađa) ili uništavanje imovine Poslodavca, odnosno omogućivanje i pomoć trećima u otuđenju ili uništavanju imovine Poslodavca, \r\n- unošenje netočnih podataka u obračun putnih troškova, putnog naloga i drugih isprava radi pribavljanja imovinske koristi za sebe ili drugog, \r\n- falsificiranje (krivotvorenje) isprava radi stjecanja materijalne koristi za sebe i drugog, \r\n- neovlašteno korištenje nacrta, dijelova projekta ili projekta i sredstava za rad radi stjecanja imovinske koristi za sebe ili drugoga,  \r\n- sklapanje poslova iz djelatnosti koju obavlja Poslodavac, bez odobrenja Poslodavca, za svoj ili tuđi račun, \r\n- pribavljanje osobne materijalne koristi u bilo kojem obliku na štetu poslodavca, a u svezi s poslovanjem Poslodavca ili radom kod Poslodavca, \r\n- bavljenje djelatnostima u svrhu privređivanja drugim tvrtkama za vrijeme zaposlenja kod Poslodavca, \r\n- pribavljanje materijalne koristi za sebe ili drugoga prilikom transakcija s kupcima, \r\n- uzrokovanje veće štete, \r\n- netočno evidentiranje ili prikazivanje rezultata rada i poslovanja Poslodavca ili pojedinog radnika, čime se nanosi šteta Poslodavcu ili pojedinom radniku, \r\n- ako radnik svojim postupcima na radu ili vezano uz rad, namjerno ili zbog krajnje nepažnje, prouzroči Poslodavcu znatniju materijalnu i/ ili nematerijalnu štetu, \r\n- oštećenje sredstava za rad, \r\n- korištenje sredstvima Poslodavca u osobne svrhe, bez odobrenja Poslodavca, \r\n- teži oblik uznemiravanja odnosno spolnog uznemiravanja, \r\n- ugrožavanje dostojanstva drugih radnika, \r\n- sudjelovanje u neredu, svađi, tuči u tijeku rada ili u svezi s radom, \r\n- izazivanje nereda, tučnjave, te grub i neciviliziran odnos prema drugim radnicima, strankama i sl., fizički i/ ili verbalni napad na poslovnog partnera,  \r\n- grubo ili nepristojno ponašanje prema poslovnim partnerima Poslodavca, \r\n- spavanje na radnom mjestu, \r\n- ometanje ili onemogućavanje organa Poslodavca u izvršavanju svojih funkcija, \r\n- ometanje drugih radnika u procesu rada kojim se izrazito otežava izvršavanje njegovih radnih obveza,  \r\n- unošenje alkohola i /ili narkotičkih sredstava u radne prostore Poslodavca, \r\n- dolazak na posao u alkoholiziranom stanju i/ ili pod utjecajem narkotičkih sredstava, \r\n- konzumiranje alkohola i/ ili narkotičkih sredstava tijekom radnog vremena, \r\n- svako drugo ponašanje koje predstavlja osobito tešku povredu radne obveze koja je određena Zakonom, Odlukama Poslodavca, općima aktima društva, sudskom praksom i sl..',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ugovor o radu može se izvanredno otkazati samo u roku od 15 dana od dana saznanja za činjenicu na kojoj se izvanredni otkaz temelji. \r\n(2) Svaki radnik obvezan je u slučaju kršenja obveze iz radnog odnosa prema odredbama ovog Pravilnika, odmah po saznanju, pisano izvijestiti voditelja organizacijske jedinice o radniku koji je povrijedio obveze, ili o osobito važnoj činjenici koja je opravdani razlog i osnova za otkaz ugovora o radu.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Stranka ugovora o radu koja izvanredno otkaže ugovor o radu, ima pravo od stranke koja je kriva za otkaz tražiti naknadu štete zbog neizvršenja ugovorom o radu preuzetih obveza. \r\n(2) U slučaju izvanrednog otkaza, Poslodavac nema obvezu pisano upozoriti radnika. ',
            },
        ],
    },
    {
        title: 'Otkaz ugovora o radu sklopljenog na određeno vrijeme',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ugovor o radu sklopljen na određeno vrijeme može se redovito otkazati samo ako je takva mogućnost otkazivanja predviđena ugovorom o radu.',
            },
        ],
    },
    {
        title: 'Oblik, obrazloženje i dostava otkaza',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Otkaz mora imati pisani oblik. Poslodavac mora u pisanom obliku obrazložiti otkaz. Otkaz se mora dostaviti osobi kojoj se otkazuje.',
            },
        ],
    },
    {
        title: 'Otkazni rok',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Otkazni rok počinje teći danom dostave otkaza ugovora o radu. \r\n(2) Otkazni rok ne teče za vrijeme trudnoće, korištenja rodiljnog, roditeljskog, posvojiteljskog dopusta, rada s polovicom punog radnog vremena, rada u skraćenom radnom vremenu zbog pojačane njege djeteta, dopusta trudnice ili majke koja doji dijete, te dopusta ili rada u skraćenom radnom vremenu radi skrbi i njege djeteta s težim smetnjama u razvoju prema posebnom propisu te za vrijeme privremene nesposobnosti za rad tijekom liječenja ili oporavka od ozljede na radu ili profesionalne bolesti, te vršenja dužnosti i prava državljana u obrani. \r\n(3) Otkazni rok ne teče za vrijeme privremene nesposobnosti za rad.\r\n(4) Ako je došlo do prekida tijeka otkaznog roka zbog privremene nesposobnosti za rad radnika, radni odnos tom radniku prestaje najkasnije istekom šest mjeseci od dana uručenja odluke o otkazu ugovora o radu. \r\n(5) Otkazni rok teče za vrijeme godišnjeg odmora, plaćenog dopusta te razdoblja privremene nesposobnost za rad radnika kojeg je Poslodavac u otkaznom roku oslobodio obveze rada.',
            },
        ],
    },
    {
        title: 'Najmanje trajanje otkaznog roka',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) U slučaju redovitog otkaza otkazni rok je najmanje: \r\n1) dva tjedna, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno manje od jedne godine, \r\n2) mjesec dana, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno jednu godinu, \r\n3) mjesec dana i dva tjedna, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno dvije godine, \r\n4) dva mjeseca, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno pet godina, \r\n5) dva mjeseca i dva tjedna, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno deset godina, \r\n6) tri mjeseca, ako je radnik u radnom odnosu kod istog poslodavca proveo neprekidno dvadeset godina.\r\n(2) Otkazni rok iz stavka 1. ovog članka radniku koji je kod poslodavca proveo u radnom odnosu neprekidno dvadeset godina, povećava se za dva tjedna ako je radnik navršio pedeset godina života, a za mjesec dana ako je navršio pedeset pet godina života. \r\n(3) Radniku kojem se ugovor o radu otkazuje zbog povrede obveze iz radnog odnosa (otkaz uvjetovan skrivljenim ponašanjem radnika) utvrđuje se otkazni rok u dužini polovice otkaznih rokova utvrđenih u stavcima 1. i 2. ovog članka.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ako radnik na zahtjev Poslodavca prestane raditi prije isteka propisanog ili ugovorenog otkaznog roka, Poslodavac mu je dužan isplatiti naknadu plaće i priznati sva ostala prava kao da je radio do isteka otkaznog roka.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Za vrijeme otkaznog roka, radnik ima pravo uz naknadu plaće biti odsutan s rada najmanje četiri sata tjedno radi traženja novog zaposlenja.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ako radnik otkazuje ugovor o radu, otkazni rok ne može biti duži od mjesec dana, ako on za to ima osobito važan razlog.',
            },
        ],
    },
    {
        title: 'Otkaz s ponudom izmijenjenog ugovora',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Odredbe koje se odnose na otkaz, primjenjuju se i na slučaj kada Poslodavac otkaže ugovor i istodobno predloži radniku sklapanje ugovora o radu pod izmijenjenim uvjetima. \r\n(2) Ako radnik prihvati ponudu Poslodavca, pridržava pravo pred nadležnim sudom osporavati dopuštenost takvog otkaza ugovora. \r\n(3) O ponudi za sklapanje ugovora o radu pod izmijenjenim uvjetima radnik se mora izjasniti u roku kojeg odredi Poslodavac, a koji ne smije biti kraći od 8 dana. \r\n(4) U slučaju otkaza ugovora o radu s ponudom izmijenjenog ugovora, rok od 15 dana u kojem radnik može od Poslodavca zahtijevati ostvarenja povrijeđenog prava teče od dana kada se radnik izjasnio o odbijanju ponude za sklapanje ugovora o radu pod izmijenjenim uvjetima, ili od dana isteka roka koji je za izjašnjenje o dostavljenoj ponudi odredio Poslodavac, ako se radnik nije izjasnio o primljenoj ponudi ili se izjasnio nakon isteka ostavljenog roka.',
            },
        ],
    },

        
    {
        title: 'Savjetovanje radničkog vijeća ili sindikalnog povjerenika o otkazu',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Namjeru da otkaže određeni ugovor o radu Poslodavac je dužan priopćiti radničkom vijeću ili sindikalnom povjereniku te je dužan o toj odluci savjetovati se (za razliku od suglasnosti, gdje je pozitivno mišljenje preduvjet donošenja odluke) s radničkim vijećem ili sindikalnim povjerenikom, u slučaju, na način i pod uvjetima propisanim Zakonom o radu.',
            },
        ],
    },
        
    {
        title: 'Otpremnina',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik kojem Poslodavac otkazuje nakon dvije godine neprekidnoga rada, osim ako se otkazuje iz razloga uvjetovanih ponašanjem radnika, ima pravo na otpremninu u iznosu koji se određuje s obzirom na dužinu prethodnoga neprekidnoga trajanja radnog odnosa s Poslodavcem. \r\n(2) Otpremnina se ne smije ugovoriti, odnosno odrediti u iznosu manjem od jedne trećine prosječne mjesečne plaće koju je radnik ostvario u tri mjeseca prije prestanka ugovora o radu, za svaku navršenu godinu rada kod Poslodavca. \r\n(3) Ukupan iznos otpremnine iz stavka 2. ovog članka ne može biti veći od šest prosječnih mjesečnih plaća koje je radnik ostvario u tri mjeseca prije prestanka ugovora o radu.',
            },
        ],
    },
    {
        title: 'Razduživanje',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Prije prestanka radnog odnosa, radnik se dužan razdužiti i vratiti Poslodavcu sve stvari, materijale i ostalo što je dobio na korištenje, u skladu s odlukama poslodavca koje reguliraju razduživanju radnika.',
            },
        ],
    },
    {
        title: 'XIV. OSTVARIVANJE PRAVA I OBVEZA IZ RADNOG ODNOSA; Odlučivanje o pravima i obvezama iz radnog odnosa',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Pravo odlučivati o pravima i obvezama iz radnog odnosa ima osoba ovlaštena za zastupanje Poslodavca.',
            },
        ],
    },
    {
        title: 'Dostava odluke o pravima i obvezama iz radnog odnosa',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Odluke o otkazu ugovora o radu dostavljaju se u poslovnim prostorima Poslodavca, tijekom radnog vremena. \r\n(2) Ako se radnik ne nalazi na radu, odluke iz stavka 1. ovog članka dostavljaju se preporučenom poštom s povratnicom na adresu stanovanja radnika, koju je radnik prijavio Poslodavcu. Odluka se smatra dostavljenom ako je istu zaprimio odrasli član radnikovog kućanstva. \r\n(3) Ako dostava ne uspije na način iz st. 2. ovog članka, odluka se ističe na oglasnoj ploči Poslodavca ili u poslovnom prostoru Poslodavca u kojem borave ili se kreću radnici Poslodavca. Protekom roka od tri dana smatra se da je odluka dostavljena radniku, što na odluci potvrđuje ovlaštena osoba Poslodavca.',
            },
        ],
    },
    {
        title: 'Sudska zaštita prava iz radnog odnosa',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik koji smatra da mu je Poslodavac povrijedio neko pravo iz radnog odnosa može u roku od petnaest dana od dostave odluke kojom je povrijeđeno njegovo pravo, odnosno od saznanja za povredu prava zahtijevati od poslodavca ostvarenje toga prava. \r\n(2) Ako Poslodavac u roku od petnaest dana od dostave zahtjeva radnika iz stavka 1. ovog članka ne udovolji tom zahtjevu, radnik može u daljnjem roku od petnaest dana zahtijevati zaštitu povrijeđenog prava pred nadležnim sudom. \r\n(3) Zaštitu povrijeđenog prava pred nadležnim sudom ne može zahtijevati radnik koji prethodno poslodavcu nije podnio zahtjev iz stavka 1. ovog članka, osim u slučaju zahtjeva radnika za naknadom štete ili drugog novčanog potraživanja iz radnog odnosa. \r\n(4) Ako je zakonom, drugim propisom, kolektivnim ugovorom ili pravilnikom o radu predviđen postupak mirnoga rješavanja nastaloga spora, rok od petnaest dana za podnošenje tužbe sudu teče od dana okončanja toga postupka. \r\n(5) Odredbe o sudskoj zaštiti prava iz radnog odnosa ne primjenjuju se na postupak zaštite dostojanstva radnika.',
            },
        ],
    },
    {
        title: 'XV. POSTUPAK I MJERE ZAŠTITE DOSTOJANSTVA RADNIKA I ZAŠTITE OD DISKRIMINACIJE; Zaštita dostojanstva radnika i zaštita od diskriminacije',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac štiti dostojanstvo radnika za vrijeme rada osiguravanjem takvih uvjeta rada u kojima neće biti izloženi bilo kojem obliku diskriminacije, uznemiravanja ili spolnog uznemiravanja (u nastavku teksta: uznemiravanje), te poduzimanjem preventivnih mjera. \r\n(2) Poslodavac je dužan zaštititi dostojanstvo radnika za vrijeme obavljanja posla od postupanja nadređenih, suradnika i osoba s kojima radnik redovito dolazi u doticaj u obavljanju svojih poslova, ako je takvo postupanje neželjeno i u suprotnosti s posebnim zakonima. \r\n(3) Poslodavac je dužan zaštititi radnika od izravne ili neizravne diskriminacije na području rada i radnih uvjeta, uključujući kriterije za odabir i uvjete pri zapošljavanju, napredovanju, profesionalnom usmjeravanju, stručnom osposobljavanju i usavršavanju te prekvalifikaciji, sukladno posebnim zakonima. \r\n(4) Dostojanstvo radnika štiti se od uznemiravanja ili spolnog uznemiravanja. \r\n(5) Uznemiravanje je svako neželjeno ponašanje uzrokovano nekim od sljedećih osnova: rase ili etničke pripadnosti ili boje kože, spola, jezika, vjere, političkog ili drugog uvjerenja, nacionalnog ili socijalnog podrijetla, imovnog stanja, članstva u sindikatu, obrazovanja, društvenog položaja, bračnog ili obiteljskog statusa, dobi, zdravstvenog stanja, invaliditeta, genetskog naslijeđa, rodnog identiteta, izražavanja ili spolne orijentacije, koje ima za cilj ili stvarno predstavlja povredu dostojanstva osobe, a koje uzrokuje strah, neprijateljsko, ponižavajuće ili uvredljivo okruženje. \r\n(6) Spolno uznemiravanje je svako verbalno, neverbalno ili fizičko neželjeno ponašanje spolne naravi koje ima za cilj ili stvarno predstavlja povredu dostojanstva osobe, koje uzrokuje strah, neprijateljsko, ponižavajuće ili uvredljivo okruženje.  \r\n(7) Ponašanje radnika koje predstavlja uznemiravanje i spolno uznemiravanje predstavlja povredu obveza iz radnog odnosa.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac će imenovati osobu koja je osim njega ovlaštena primati i rješavati pritužbe vezane za zaštitu dostojanstva radnika. \r\n(2) Poslodavac ili osoba iz stavka 1. ovog članka dužna je, što je moguće prije, a najkasnije u roku od 8 dana od dostave pritužbe, ispitati pritužbu i poduzeti sve potrebne mjere primjerene pojedinom slučaju radi sprječavanja nastavka uznemiravanja ili spolnog uznemiravanja ako utvrdi da ono postoji.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Osoba koja je osim Poslodavca ovlaštena primati i rješavati pritužbe vezane za zaštitu dostojanstva radnika (dalje: ovlaštena osoba) dužna je bez odgode razmotriti pritužbu i u vezi s njom provesti dokazni postupak radi potpunog i istinitog utvrđivanja činjeničnog stanja. \r\n(2) Ovlaštena osoba u vezi s pritužbom može saslušavati podnositelja pritužbe, svjedoke, osobu za koju se tvrdi da je podnositelja pritužbe uznemiravala ili spolno uznemiravala, obaviti suočenje, obaviti očevid, te prikupljati druge dokaze kojima se može dokazati osnovanost pritužbe.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) O svim radnjama koje poduzme u cilju utvrđivanja činjeničnog stanja ovlaštena osoba će sastaviti zapisnik ili službenu bilješku. \r\n(2) Zapisnik će se u pravilu sastaviti prilikom saslušanja svjedoka, podnositelja pritužbe i osobe za koju podnositelj tvrdi da ga je uznemiravala ili spolno uznemiravala, te u slučaju njihovog suočenja. Zapisnik potpisuju sve osobe koje su bile nazočne njegovom sastavljanju. \r\n(3) U zapisniku će se posebno navesti da je ovlaštena osoba sve nazočne upozorila da su svi podaci utvrđeni u postupku zaštite dostojanstva radnika tajni, te da ih je upozorila na posljedice odavanja te tajne.\r\n(4) Službena bilješka će se u pravilu sastaviti pri obavljanju očevida ili prikupljanju drugih dokaza. Službenu bilješku potpisuje ovlaštena osoba i zapisničar koji je bilješku sastavio.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Nakon provedenog postupka ovlaštena će osoba u pisanom obliku izraditi odluku u kojoj će: \r\n1. utvrditi da postoji uznemiravanje ili spolno uznemiravanje podnositelja pritužbe ili, \r\n2. utvrditi da ne postoji uznemiravanje ili spolno uznemiravanje podnositelja pritužbe.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) U slučaju iz podstavka 1. prethodnoga članka, ovlaštena će osoba u svojoj odluci navesti sve činjenice koje dokazuju da je podnositelj pritužbe uznemiravan ili spolno uznemiravan. \r\n(2) U toj odluci, ovlaštena osoba će predložiti nadležnom tijelu Poslodavca da osobi koja je podnositelja pritužbe uznemiravala ili spolno uznemiravala izrekne mjeru zbog povrede radne obveze (pisano upozorenje na obveze iz radnog odnosa, redoviti ili izvanredni otkaz ugovora o radu), te predložiti poduzimanje drugih mjera koje su primjerene pojedinom slučaju radi sprječavanja nastavka uznemiravanja. \r\n(3) U slučaju iz podstavka 2. prethodnog članka, ovlaštena osoba će odbiti pritužbu podnositelja zahtjeva.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Nadležno tijelo Poslodavca će na temelju provedenog postupka i prijedloga ovlaštene osobe poduzeti mjere koje su primjerene odnosnom slučaju radi sprječavanja nastavka uznemiravanja, te osobi koja je radnika uznemiravala ili spolno uznemiravala izreći odgovarajuću mjeru zbog povrede obveza iz radnog odnosa.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ako Poslodavac u roku od 8 dana ne poduzme mjere za sprječavanje uznemiravanja ili spolnog uznemiravanja ili ako su mjere koje je poduzeo očito neprimjerene, radnik koji je uznemiravan ili spolno uznemiravan ima pravo prekinuti rad dok mu se ne osigura zaštita, pod uvjetom da je u daljnjem roku od 8 dana zatražio zaštitu pred nadležnim sudom.',
            },
        ],
    },
        
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Ako postoje okolnosti zbog kojih nije opravdano očekivati da će Poslodavac zaštititi dostojanstvo radnika, radnik nije dužan dostaviti pritužbu Poslodavcu i ima pravo prekinuti rad, pod uvjetom da je zatražio zaštitu pred nadležnim sudom i o tome obavijestio Poslodavca u roku od osam dana od dana prekida rada. \r\n(2) Za vrijeme prekida rada iz prethodnog članka, kao i u slučaju iz stavka 1. ovog članka radnik ima pravo na naknadu plaće koju bi ostvario da je radio. ',
            },
        ],
    },
        
    {
        title: 'XV. MJERE KONTROLE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može, kad to njegovi interesi zahtijevaju, dati nalog za obavljanje pregleda, odnosno, utvrditi način kontrole ljudi i opreme pri ulazu i izlazu iz poslovnih prostora radi sprečavanja otuđivanja imovine Poslodavca.\r\n(2) Izbjegavanje kontrole može biti razlog za otkaz ugovora o radu.',
            },
        ],
    },
        
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Poslodavac može tijekom radnog vremena provesti postupak alkotestiranja radnika. Alkotestiranje radnika provodi osposobljena osoba imenovana od strane poslodavca koja je osposobljena za postupak alkotestiranja. \r\n(2) Radnik ovlašten za provođenje postupka alkotestiranja ovlašten je provesti alkotestiranje u službenim prostorijama poslodavca. \r\n(3) Izbjegavanje postupka alkotestiranja može biti razlog za otkaz ugovora o radu.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Radnik ovlašten za provođenje alkotestiranja ovlašten je alkotestirati sve radnike, svih zanimanja i bez obzira na radna mjesta na kojima su zaposleni. \r\n(2) Provođenje postupka alkotestiranja nije potrebno najavljivati niti na bilo koji način obavijestiti radnike o tome da će se alkotestiranje provoditi. \r\n(3) Radnik koji provodi postupak alkotestiranja dužan je pridržavati se uputa i mjera iz Naputka o provođenju alkotestiranja, ispuniti sve propisane obrasce iz Naputka te poduzeti mjere.',
            },
        ],
    },
        
    {
        title: 'XVI. PRIJELAZNE I ZAVRŠNE ODREDBE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                help: "Pravilnik o radu ne može stupiti na snagu prije isteka roka od osam dana od dana objave. U pravilniku se mora naznačiti dan stupanja na snagu.",
                content: '(1) Stupanjem na snagu ovog Pravilnika stavljaju se izvan snage sve odredbe prethodno donesenih Pravilnika o radu poslodavca. \r\n(2) Ovaj Pravilnik stupa na snagu i primjenjuje se nakon proteka roka od 8 dana od dana objave na oglasnoj ploči Poslodavca. \r\n(3) Izmjene i dopune ovog Pravilnika donose se na način propisan Zakonom o radu za njegovo donošenje.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '(1) Na pitanja koja nisu uređena ovim Pravilnikom, neposredno će se primijeniti odredbe zakona, kolektivnog ugovora i ugovora o radu.',
            },
        ],
    },
    {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
            {
                type: 'input',
                mandatory: true,
                parts: [
                    {
                        type: 'text',
                        content: 'U'
                    },
                    {
                        type: 'input',
                        value: '',
                        placeholder: "Upišite mjesto",
                        required: true
                    },
                    {
                        type: 'text',
                        content: ', dana'
                    },
                    {
                        type: 'date',
                        value: new Date(),
                        required: true
                    },
                    {
                        type: 'text',
                        content: 'godine.',
                    }
                ]
            },
        ]
    },
    {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
    },
    {
        static: true,
        mandatory: false,
        type: 4, 
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '\r\nOvaj Pravilnik objavljen je na oglasnoj ploči Poslodavca dana _______________, a stupio je na snagu dana _______________ 20__. godine. \r\n\r\n Potvrđuje: \r\n\r\n_________________________ \r\n\r\n\r\nSkinuto s oglasne ploče Društva dana____________20__. \r\n\r\n\r\nPotvrđuje:\r\n\r\n\ _________________________', 
            }
        ]
    },
],
};




// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/222_pravilnik_o_radu.ts